import React, { Component } from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import { Button, Icon } from "@evertrue/et-components";
import CDCModalRow from "./cdc-modal-row";
import CDCStatus from "./cdc-status";
import { WithCDCDependencies } from "../contexts/cdc-dependencies-context";

class CDCPanelController extends Component {
  static propTypes = {
    contact: PropTypes.object,
    contactData: PropTypes.array,
    dataKey: PropTypes.string,
    icon: PropTypes.string,
    generateUID: PropTypes.func,
    renderLabel: PropTypes.func,
    getValue: PropTypes.func,
    getPlaceholder: PropTypes.func,
    onSuccess: PropTypes.func,
    onFailure: PropTypes.func,
    dependencies: PropTypes.object.isRequired,
  };

  static defaultProps = {
    contact: {},
    contactData: [],
    dataKey: "",
    icon: "",
    generateUID: _.noop,
    renderLabel: _.noop,
    getValue: _.noop,
    getPlaceholder: _.noop,
    onSuccess: _.noop,
    onFailure: _.noop,
  };

  state = { currentActive: "", panelStatus: "view", submitStatus: "" };

  componentDidUpdate(prevProps) {
    if (prevProps.dataKey !== this.props.dataKey) {
      this.resetPanel();
    }
  }

  resetPanel = () => {
    this.setState({ currentActive: "", panelStatus: "view", submitStatus: "" });
  };

  handleAddNew = () => {
    this.setState({ currentActive: "new", panelStatus: "new" });
  };

  handleEdit = id => {
    this.setState({ currentActive: id, panelStatus: "edit" });
  };

  handleRetire = id => {
    this.setState({ currentActive: id, panelStatus: "retire" });
  };

  handleCancel = () => {
    this.resetPanel();
  };

  handleSubmit = (dataType, panel) => {
    this.props.dependencies.sendMixPanel("contact_suggestion", { type: panel, data_type: dataType });
    this.resetPanel();
    this.setState({ submitStatus: "success" });
    this.props.onSuccess();
  };

  handleFailure = () => {
    this.resetPanel();
    this.setState({ submitStatus: "error" });
    this.props.onFailure();
  };

  renderContactData() {
    const { panelStatus, currentActive } = this.state;
    const { contact, contactData, dataKey } = this.props;
    const sortedByPrimary = _.sortBy(contactData, field => (field.primary && field.primary.value ? 0 : 1));
    if (sortedByPrimary.length > 0) {
      return sortedByPrimary.map((field, index) => {
        const uid = this.props.generateUID(field);
        const isActive = currentActive === uid;
        return (
          <CDCModalRow
            contact={contact}
            key={uid + index} // eslint-disable-line
            id={String(uid)}
            dataType={dataKey}
            valueDescription={field.type ? field.type.value.toLowerCase() : null}
            value={this.props.getValue(field)}
            label={this.props.renderLabel(field)}
            panelStatus={panelStatus}
            onEdit={this.handleEdit}
            onRetire={this.handleRetire}
            onCancel={this.handleCancel}
            onSuccess={this.handleSubmit}
            onFailure={this.handleFailure}
            isActive={isActive}
          />
        );
      });
    }
    return <span className="cdc-controller--empty">No Contact Data</span>;
  }

  renderMisc() {
    const uid = "misc_edit";
    return (
      <CDCModalRow
        contact={this.props.contact}
        id={String(uid)}
        dataType={"misc"}
        label={"Add Misc"}
        panelStatus="new"
        onEdit={this.handleEdit}
        onRetire={this.handleRetire}
        onCancel={this.handleCancel}
        onSuccess={this.handleSubmit}
        onFailure={this.handleFailure}
        isActive={true}
      />
    );
  }

  renderNewForm() {
    if (this.state.panelStatus === "new") {
      const { contact, dataKey } = this.props;
      const { currentActive, panelStatus } = this.state;
      const isActive = currentActive === "new";
      return (
        <CDCModalRow
          contact={contact}
          id={"new"}
          dataType={dataKey}
          label={`new ${dataKey}`}
          placeholder={this.props.getPlaceholder(dataKey)}
          panelStatus={panelStatus}
          onEdit={this.handleEdit}
          onRetire={this.handleRetire}
          onCancel={this.handleCancel}
          onSuccess={this.handleSubmit}
          onFailure={this.handleFailure}
          isActive={isActive}
        />
      );
    }
  }

  render() {
    return (
      <section className="cdc-panel-controller">
        {this.state.submitStatus ? <CDCStatus status={this.state.submitStatus} /> : null}
        <div className="cdc-controller--add">
          <Icon className="cdc-controller-icon" icon={this.props.icon} size={2} />
          {this.state.panelStatus === "view" && this.props.dataKey !== "misc" ? (
            <Button onClick={this.handleAddNew}>
              <Icon icon="add" />
              Add New
            </Button>
          ) : null}
        </div>
        {this.renderNewForm()}
        {this.props.dataKey !== "misc" ? this.renderContactData() : this.renderMisc()}
      </section>
    );
  }
}

export default WithCDCDependencies(CDCPanelController);
